import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

const adminTabs = ["overview", "users", "charts", "friendships"] as const;
const adminSorts = ["profile", "username", "visibility", "createdAt", "lastLoginAt"] as const;
type AdminSearch = {
  tab?: (typeof adminTabs)[number];
  search?: string;
  page?: number;
  sort?: (typeof adminSorts)[number];
  direction?: "asc" | "desc";
};

function validateAdminSearch(search: Record<string, unknown>): AdminSearch {
  const page = Number(search.page ?? 1);
  return {
    tab: adminTabs.includes(search.tab as (typeof adminTabs)[number])
      ? (search.tab as (typeof adminTabs)[number])
      : "overview",
    search: typeof search.search === "string" ? search.search.trim() : "",
    page: Number.isInteger(page) && page > 0 ? page : 1,
    sort: adminSorts.includes(search.sort as (typeof adminSorts)[number])
      ? (search.sort as (typeof adminSorts)[number])
      : "createdAt",
    direction: search.direction === "asc" ? "asc" : "desc",
  };
}

export const Route = createFileRoute("/admin")({
  ssr: false,
  validateSearch: validateAdminSearch,
  head: () => pageHead("Admin", { canonicalPath: "/admin", robots: "noindex, nofollow" }),
});
